import {
  FaRegComment,
  FaHeart,
  FaRetweet,
  FaUserPlus,
  FaAt,
} from "react-icons/fa";

export const NOTIFICATION_TYPES = {
  comment:         { icon: FaRegComment, color: "spiders-success",     bgClass: "bg-green-500",   verb: "commented on your post" },
  reply:           { icon: FaRegComment, color: "spiders-success",     bgClass: "bg-green-500",   verb: "replied to your comment" },
  thread_activity: { icon: FaRegComment, color: "spiders-success",     bgClass: "bg-green-500",   verb: "commented in a thread you joined" },
  like:            { icon: FaHeart,      color: "spiders-error",       bgClass: "bg-red-500",     verb: "liked your post" },
  repost:          { icon: FaRetweet,    color: "spiders-accent-400",  bgClass: "bg-orange-500",  verb: "reposted your post" },
  follow:          { icon: FaUserPlus,   color: "spiders-primary-400", bgClass: "bg-teal-500",    verb: "started following you" },
  mention:         { icon: FaAt,         color: "spiders-warning",     bgClass: "bg-amber-500",   verb: "mentioned you" },
};

export function timeAgo(dateString) {
  const seconds = Math.floor((Date.now() - new Date(dateString)) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 172800) return "Yesterday";
  return new Date(dateString).toLocaleDateString();
}
